<template>
  <div class="personnummer-container">
    <ul class="nav nav-tabs">
      <li class="nav-item">
        <a class="nav-link" :class="{ active: activeTab === 'generator' }" href="#" @click.prevent="activeTab = 'generator'">Generator</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" :class="{ active: activeTab === 'validator' }" href="#" @click.prevent="activeTab = 'validator'">Validator</a>
      </li>
    </ul>

    <!-- Generator Tab -->
    <div v-if="activeTab === 'generator'" class="tab-content">
      <h3>Generer fiktive personnummer</h3>
      <div class="card-body">
        Generer dine egne fiktive personnummer. Personnummerene er
        MOD11-gyldige. Dataene genereres i din egen nettleser. Merk at det ikke gjøres noen sjekk på om personnummerene
        allerede er generert for ekte, virkelig mennesker.
      </div>

      <form @submit.prevent="lagPersonnummer">
        <fieldset class="form-group">
          <div class="row">
            <div class="col-sm-2">
              <button type="submit" class="btn btn-primary">Generer</button>
            </div>
            <div class="col-sm-2">
              <legend class="col-form-label pt-0">Kjønn</legend>
              <div class="form-check">
                <input class="form-check-input" type="radio" name="gridRadios" id="kjonnMann" value="MANN"
                       v-model="inputKjonn" checked>
                <label class="form-check-label" for="kjonnMann">
                  Mann
                </label>
              </div>
              <div class="form-check">
                <input class="form-check-input" type="radio" name="gridRadios" id="kjonnKvinne" value="KVINNE"
                       v-model="inputKjonn">
                <label class="form-check-label" for="kjonnKvinne">
                  Kvinne
                </label>
              </div>
            </div>
            <div class="col-sm-3">
              <legend class="col-form-label pt-0">Type</legend>
              <select class="form-select" aria-label="Default select example" v-model="inputPersonidentType">
                <option value="FNR" selected>Fødselsnummer</option>
                <option value="DNR">D-nummer</option>
              </select>

            </div>
            <div class="col-sm-1">
              <legend class="col-form-label pt-0">Dag</legend>
              <input type="number" v-model="inputDay" min="1" max="31"/>
            </div>
            <div class="col-sm-1">
              <legend class="col-form-label pt-0">Måned</legend>
              <input type="number" v-model="inputMonth" min="1" max="12"/>
            </div>
            <div class="col-sm-1">
              <legend class="col-form-label pt-0">År</legend>
              <input type="number" v-model="inputYear" min="1900" max="2022"/>
            </div>
          </div>
        </fieldset>
      </form>
      <div class="row well" id="personnummere_liste">
        <div v-for="personnummer in personnummere" :key="personnummer.uuid" class="col-sm-3 card">
          <div class="card-content">
            <button @click="fjernPersonnummer(personnummer.uuid)" type="button" class="btn-close close-button" aria-label="Close"></button>
            <p>
              <span class="badge bg-secondary me-2"> {{ personnummer.kjonn }}</span>
              <span class="badge bg-secondary"> {{ personnummer.type }}</span>
            </p>
            <p>
              {{ personnummer.ident }}
              <button @click="leggVerdiTilClipboard(personnummer.ident)" type="button"
                      class="bi bi-clipboard-check copy-button" title="Kopier til utklippstavle">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                     viewBox="0 0 16 16">
                  <path fill-rule="evenodd" d="M10.854 7.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708 0z"></path>
                  <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"></path>
                  <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"></path>
                </svg>
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- Validator Tab -->
    <div v-if="activeTab === 'validator'" class="tab-content">
      <h3>Valider fødselsnummer</h3>
      <form>
        <fieldset class="form-group">
          <div class="row">
            <div class="col-sm-4">
              <input v-model="typedPersonnummer" type="text" placeholder="personnummer" class="form-control form-control-lg"/>
            </div>
            <div class="col-sm-8">
              <p class="validation-message"> {{ this.validatorText }}</p>
            </div>
          </div>
        </fieldset>
      </form>
      <div v-if="personnummerData" class="data-display">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title">Personnummer informasjon</h5>
            <div class="info-grid">
              <div class="info-item">
                <strong>Gyldig MOD11:</strong>
                <span :class="personnummerData.isValid ? 'badge bg-success' : 'badge bg-danger'">
                  {{ personnummerData.isValid ? 'Ja' : 'Nei' }}
                </span>
              </div>
              <div class="info-item">
                <strong>Type:</strong>
                <span class="badge bg-secondary">{{ personnummerData.type }}</span>
              </div>
              <div class="info-item">
                <strong>Fødselsdato:</strong>
                <span>{{ personnummerData.birthDate }}</span>
              </div>
              <div class="info-item">
                <strong>Kjønn:</strong>
                <span class="badge bg-info">{{ personnummerData.gender }}</span>
              </div>
              <div class="info-item">
                <strong>Individnummer:</strong>
                <span>{{ personnummerData.birthNumber }}</span>
              </div>
              <div class="info-item">
                <strong>Kontrollsiffer:</strong>
                <span>{{ personnummerData.controlDigits }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'personnummer',
  data() {
    return {
      activeTab: 'generator',
      // Generator data
      inputYear: 0,
      inputMonth: 0,
      inputDay: 0,
      inputKjonn: 'MANN',
      inputPersonidentType: 'FNR',
      personnummere: [],
      // Validator data
      typedPersonnummer: ""
    }
  },
  computed: {
    validatorText() {
      return this.validateNotNumbers() + this.validateLength()
    },
    personnummerData() {
      if (this.typedPersonnummer.length !== 11 || !/^\d+$/.test(this.typedPersonnummer)) {
        return null
      }

      const pnr = this.typedPersonnummer

      // Extract components
      let day = parseInt(pnr.substring(0, 2))
      const month = parseInt(pnr.substring(2, 4))
      const year = parseInt(pnr.substring(4, 6))
      const birthNumber = pnr.substring(6, 9)
      const controlDigits = pnr.substring(9, 11)

      // Detect type (DNR if day > 40)
      const isDNR = day > 40
      const type = isDNR ? 'D-nummer' : 'Fødselsnummer'

      // Adjust day for DNR
      if (isDNR) {
        day = day - 40
      }

      // Determine century from birth number
      const birthNumberInt = parseInt(birthNumber)
      let century
      if (birthNumberInt >= 0 && birthNumberInt <= 499) {
        century = 1900
      } else if (birthNumberInt >= 500 && birthNumberInt <= 749 && year >= 54) {
        century = 1800
      } else if (birthNumberInt >= 500 && birthNumberInt <= 999 && year <= 39) {
        century = 2000
      } else if (birthNumberInt >= 900 && birthNumberInt <= 999 && year >= 40) {
        century = 1900
      } else {
        century = 1900 // Default
      }

      const fullYear = century + year

      // Format birth date
      const birthDate = `${String(day).padStart(2, '0')}.${String(month).padStart(2, '0')}.${fullYear}`

      // Extract gender (9th digit, index 8)
      const genderDigit = parseInt(pnr.charAt(8))
      const gender = genderDigit % 2 === 0 ? 'Kvinne' : 'Mann'

      // Validate MOD11
      const isValid = this.validateMOD11(pnr)

      return {
        isValid,
        type,
        birthDate,
        gender,
        birthNumber,
        controlDigits
      }
    }
  },
  methods: {
    // Generator methods
    leggVerdiTilClipboard(ident) {
      navigator.clipboard.writeText(ident);
    },
    fjernPersonnummer(ident) {
      this.personnummere = this.personnummere.filter(it => it.uuid !== ident)
    },
    lagPersonnummer() {
      let personnummer = false
      do {
        personnummer = this.genererPersonnummer()
      } while(personnummer === false)
      this.personnummere.push(personnummer)
    },
    genererPersonnummer() {
      let day = String(this.adjustForDNR(this.inputDay)).padStart(2, '0')
      let month = String(this.inputMonth).padStart(2, '0')
      let year = String(this.inputYear).padStart(2, '0').slice(-2);

      let withoutControlDigits = day + month + year + this.getBirthNumber(this.inputKjonn)

      let control1 = this.controlNumbers(withoutControlDigits, [3, 7, 6, 1, 8, 9, 4, 5, 2]);
      let control2 = this.controlNumbers(withoutControlDigits + control1, [5, 4, 3, 2, 7, 6, 5, 4, 3, 2]);

      if (control1 === 10 || control2 === 10) {
        return false
      } else {
        const personnummer = {
          uuid: this.uuidv4(),
          ident: `${withoutControlDigits}${control1}${control2}`,
          kjonn: this.inputKjonn,
          type: this.inputPersonidentType
        }
        return personnummer
      }
    },
    uuidv4() {
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
          (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
      )
    },
    checksum(withoutControlDigits, factors) {
      let sum = 0;
      for (let i = 0; i < factors.length; i++) {
        sum += parseInt(withoutControlDigits.charAt(i), 10) * factors[i];
      }
      return sum;
    },
    controlNumbers(withoutControlDigits, factors) {
      let number = 11 - (this.checksum(withoutControlDigits, factors) % 11);
      return number !== 11 ? number : 0;
    },
    adjustForDNR(day) {
      if (this.inputPersonidentType === 'DNR') {
        return day + 40
      }
      return day
    },
    getBirthNumber(kjonn) {
      let x = Math.floor((Math.random() * 1000));
      if (kjonn === 'KVINNE') {
        x += (x % 2 === 0 ? 0 : -1);
      } else {
        x += (x % 2 === 0 ? 1 : 0);
      }
      return String(x).padStart(3, '0')
    },
    // Validator methods
    validateNotNumbers() {
      if(this.typedPersonnummer.length > 0 && !/^\d+$/.test(this.typedPersonnummer)) {
        return "Må kun inneholde siffer. "
      }
      return ""
    },
    validateLength() {
      if (this.typedPersonnummer.length === 0) {
        return ""
      }
      if(this.typedPersonnummer.length < 11) {
        return "Personnummer er for kort."
      } else if (this.typedPersonnummer.length > 11) {
        return "Personnummer er for langt."
      }
      return ""
    },
    validateMOD11(personnummer) {
      const control1Expected = this.calculateControlDigit(
        personnummer.substring(0, 9),
        [3, 7, 6, 1, 8, 9, 4, 5, 2]
      )

      if (control1Expected === 10 || control1Expected !== parseInt(personnummer.charAt(9))) {
        return false
      }

      const control2Expected = this.calculateControlDigit(
        personnummer.substring(0, 10),
        [5, 4, 3, 2, 7, 6, 5, 4, 3, 2]
      )

      if (control2Expected === 10 || control2Expected !== parseInt(personnummer.charAt(10))) {
        return false
      }

      return true
    },
    calculateControlDigit(digits, factors) {
      let sum = 0
      for (let i = 0; i < factors.length; i++) {
        sum += parseInt(digits.charAt(i)) * factors[i]
      }
      const remainder = sum % 11
      const controlDigit = 11 - remainder
      return controlDigit === 11 ? 0 : controlDigit
    }
  },
  mounted() {
    this.inputDay = Math.floor(Math.random() * 28) + 1
    this.inputMonth = Math.floor(Math.random() * 12) + 1
    this.inputYear = Math.floor(Math.random() * (2021 - 1945 + 1) + 1945)
  }
}
</script>

<style scoped>
.personnummer-container {
  padding: 10px;
}

.nav-tabs {
  margin-bottom: 20px;
}

.tab-content {
  padding: 10px;
}

.card-body {
  width: 80%;
  margin: 20px;
}

form, #personnummere_liste {
  margin: 10px;
  padding-bottom: 20px;
}

.card-content {
  position: relative;
  padding: 10px;
}

.close-button {
  position: absolute;
  top: 8px;
  right: 8px;
}

.copy-button {
  margin-left: 10px;
}

.validation-message {
  color: #dc3545;
  font-weight: 500;
  margin-top: 8px;
}

.data-display {
  padding: 20px;
  margin-top: 20px;
}

.data-display .card {
  max-width: 600px;
}

.info-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
  margin-top: 15px;
}

.info-item {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.info-item strong {
  font-size: 0.9rem;
  color: #6c757d;
}

.info-item span {
  font-size: 1rem;
}

.badge {
  width: fit-content;
  padding: 6px 12px;
}
</style>
